<template>
  <el-container>
    <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
      <el-menu
        :default-openeds="['1']"
        default-active="1_1"
        @select="handleSelect"
      >
        <el-submenu index="1">
          <template slot="title"
            ><i class="el-icon-help"></i>{{ $t("help.help_center") }}</template
          >
          <el-menu-item-group>
            <template slot="title">{{ $t("nav.data_manage") }}</template>
            <el-menu-item index="1_1">{{ $t("_data.add_data") }}</el-menu-item>
          </el-menu-item-group>
          <el-menu-item-group>
            <template slot="title">
              {{ $t("nav.MRI_analysis") }}
            </template>

            <el-menu-item index="1_2">
              {{ $t("service.create_task") }}
            </el-menu-item>
            <el-menu-item index="1_3">
              {{ $t("project.p_res") }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header style="text-align: right; font-size: 12px">
        <span>{{ current_title }}</span>
      </el-header>

      <el-main>
        <div v-if="current_page === '1_1'">
          <div class="help-text text-center my-3">
            {{ $t("help.help_1_1") }}
          </div>
          <div>
            <img :src="help_1_1" alt="" width="100%" />
          </div>
        </div>

        <div v-if="current_page === '1_2'">
          <div>
            <img :src="help_1_2" alt="" width="100%" />
          </div>
        </div>
        <div v-if="current_page === '1_3'">
          <div>
            <img :src="help_1_3" alt="" width="100%" />
          </div>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>
  <script>
import help_1_1 from "@/assets/help/1_1.gif";
import help_1_2 from "@/assets/help/1_2.gif";
import help_1_3 from "@/assets/help/1_3.gif";

export default {
  data() {
    return {
      current_title: "Help Center",
      current_page: "1_1",
      help_1_1,
      help_1_2,
      help_1_3,
    };
  },
  mounted() {
    document.title = "Help Center";
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key);
      this.current_page = key;
    },
  },
};
</script>

<style scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}
</style>
  